import React, { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from './ConfirmationAndInformationPoup';
import { dismissAlertPopup, getAlertPopupSnapshot, subscribeAlertPopup } from '../../utils/alertPopup';
const POPUP_TYPE_BY_SEVERITY = {
    success: POPUP_TYPE.SUCCESS_ALERT,
    error: POPUP_TYPE.ERROR_ALERT,
    info: POPUP_TYPE.INFO_ALERT,
    warn: POPUP_TYPE.VALIDATION_WARNING,
};
const AlertPopupContainer = () => {
    const [t] = useTranslation('global');
    const current = useSyncExternalStore(subscribeAlertPopup, getAlertPopupSnapshot);
    if (!current)
        return null;
    const titleBySeverity = {
        success: t('GENERIC_STRINGS.AlertPopup.titleSuccess'),
        error: t('GENERIC_STRINGS.AlertPopup.titleError'),
        info: t('GENERIC_STRINGS.AlertPopup.titleInfo'),
        warn: t('GENERIC_STRINGS.AlertPopup.titleWarning'),
    };
    return (React.createElement(ConfirmationAndInformationPoup, { open: true, popupType: POPUP_TYPE_BY_SEVERITY[current.severity], titleText: titleBySeverity[current.severity], message: current.message, acceptBtnText: t('GENERIC_STRINGS.AlertPopup.acceptBtnText'), acceptCallBack: dismissAlertPopup }));
};
export default AlertPopupContainer;
